import { createActions } from 'reduxsauce';

var _createActions = createActions({
  toggleSidenav: ['secondaryNavVisible']
}, {
  prefix: 'HEADER_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};